import { DataFilterInputType } from "./DataFilterInputType";
import IDataFilterBaseHandler from "./IDataFilterBaseHandler";
import IDataFilterDescriptor from "./IDataFilterDescriptor";
import DataFilterEnumMap from "./enumCheckBox/DataFilterEnumMap";
import IDataFilterEnumValue from "./enumCheckBox/IDataFilterEnumValue";
import IDataFilterComponentHandler from "./IDataFilterComponentHandler";
import { DataFilterHandlersMapper } from "./dataFilterHandlersMapper";
import { injectable } from "inversify";

@injectable()
export default abstract class DataFilterBaseHandler
  implements IDataFilterBaseHandler
{
  processFilter(
    jsonFilterDescriptor: string,
    urlParams: URLSearchParams
  ): IDataFilterDescriptor[] {
    // Načtení defaultního descriptoru z JSONu
    let descriptors = this.getDescriptorsFromJson(jsonFilterDescriptor);
    if (!descriptors || descriptors.length === 0) return [];

    // Pro enumy dogeneruju položky do descriptoru
    this.addEnumCheckBoxDescriptorValues(descriptors);
    this.addEnumRadioBoxDescriptorValues(descriptors);
    this.addEnumSelectInputBoxDescriptorValues(descriptors);

    // Přidám nastavení ze state nebo store
    this.setDescriptorValuesFromUrlParams(descriptors, urlParams);

    return descriptors;
  }

  setDescriptorValuesToUrlParams(
    descriptors: IDataFilterDescriptor[],
    urlParams: URLSearchParams
  ): void {
    descriptors.forEach((descriptor) => {
      const handler: IDataFilterComponentHandler = this.getDataFilterHandler(
        descriptor.userInputType
      );
      handler.setDescriptorValuesToUrlParams(descriptor, urlParams);
    });
  }

  private getDescriptorsFromJson(
    jsonFilterDescriptor: string
  ): IDataFilterDescriptor[] {
    try {
      const descriptors = JSON.parse(
        jsonFilterDescriptor
      ) as unknown as IDataFilterDescriptor[];

      if (descriptors && descriptors.length > 0) {
        return descriptors;
      }
    } catch (error) {}

    return [];
  }

  private addEnumCheckBoxDescriptorValues(
    descriptors: IDataFilterDescriptor[]
  ): void {
    descriptors.forEach((descriptor) => {
      if (descriptor.userInputType === DataFilterInputType.EnumCheckBox) {
        this.addValuesToEnumDescriptor(descriptor);
      }
    });
  }

  private addEnumRadioBoxDescriptorValues(
    descriptors: IDataFilterDescriptor[]
  ): void {
    descriptors.forEach((descriptor) => {
      if (descriptor.userInputType === DataFilterInputType.EnumRadioBox) {
        this.addValuesToEnumDescriptor(descriptor);
      }
    });
  }

  private addEnumSelectInputBoxDescriptorValues(
    descriptors: IDataFilterDescriptor[]
  ): void {
    descriptors.forEach((descriptor) => {
      if (descriptor.userInputType === DataFilterInputType.EnumSelectInputBox) {
        this.addValuesToEnumDescriptor(descriptor);
      }
    });
  }

  private addValuesToEnumDescriptor(
    filterDescriptor: IDataFilterDescriptor
  ): void {
    // Získám enum a jeho klíče
    const enumMap = new DataFilterEnumMap() as any;
    const selectedEnum = enumMap[filterDescriptor.name];
    if (!selectedEnum) return;

    // Enum klíče
    const enumKeys: string[] = Object.keys(selectedEnum);
    if (enumKeys.length === 0) return;

    // Přidání hodnot enumů do descriptoru
    enumKeys.forEach((enumKey) => {
      let value = (filterDescriptor.value as IDataFilterEnumValue[]).find(
        (x) => x.key === enumKey
      );
      // Pokud nenajdu existující value, vytvořím novou
      if (!value) {
        value = {
          key: enumKey,
          value: false,
        };

        (filterDescriptor.value as IDataFilterEnumValue[]).push(value);
      }
    });
  }

  private setDescriptorValuesFromUrlParams(
    descriptors: IDataFilterDescriptor[],
    urlParams: URLSearchParams
  ) {
    descriptors.forEach((descriptor) => {
      const handler: IDataFilterComponentHandler = this.getDataFilterHandler(
        descriptor.userInputType
      );
      handler.setDescriptorValuesFromUrlParams(descriptor, urlParams);
    });
  }

  getDataFilterHandler(
    userInputType: DataFilterInputType
  ): IDataFilterComponentHandler {
    return DataFilterHandlersMapper[userInputType]();
  }
}
